const normalizedValue = (value) => String(value || '').trim().toLowerCase();

const isExplicitlyEnabled = (value) => (
  value === true || value === 1 || value === '1'
);

/**
 * Prefer the backend eligibility decision whenever it is present. Older API
 * responses did not expose that field, so only those responses use the
 * conservative Stripe + saved card + unpaid fallback.
 */
export const canCaptureSavedCard = (order = {}) => {
  if (order.can_capture_saved_card !== null && order.can_capture_saved_card !== undefined) {
    return isExplicitlyEnabled(order.can_capture_saved_card);
  }

  return (
    normalizedValue(order.stripe_payment_method_type) === 'stripe'
    && isExplicitlyEnabled(order.has_saved_card)
    && Number(order.payment_status) === 0
  );
};

export const isStripePayLaterOrder = (order = {}) => (
  normalizedValue(order.stripe_payment_method_type) === 'stripe'
  && normalizedValue(order.stripe_payment_timing) === 'pay_later'
);

export const getSavedCardActionLabel = () => 'Pay for Order';

export const getSavedCardDetails = (order = {}) => [
  order.stripe_account_label,
  order.stripe_card_brand,
  order.stripe_card_last4 ? `**** ${order.stripe_card_last4}` : null,
].filter(Boolean).join(' - ');

export const getSavedCardActionTooltip = (order = {}) => {
  const label = getSavedCardActionLabel(order);
  const details = getSavedCardDetails(order);
  return details ? `${label} - ${details}` : label;
};

export const getSavedCardConfirmationCopy = (order = {}) => {
  const label = getSavedCardActionLabel(order);

  return {
    title: `${label}?`,
    content: 'Pay for this order using the saved card on the client account.',
  };
};
